import { SUPER_ADMIN } from 'utils/constants/roles';

export const canAccessGCPBillingData = (
  userType: string | undefined,
  billingEnabled: boolean
) => userType === SUPER_ADMIN && billingEnabled;
